import { Button, Form, Input, message } from "antd";
import { useMemo, useState } from "react";
import logo from "../../imgs/home/logo.png";
import styles from "./index.module.scss";
import { useCountDown, useRequest } from "ahooks";
import { getCode, resetPassword } from "../../api/auth";
import useAuthStore from "../../store/auth";
/**
 * 重置密码
 */
export default function ResetPassword({ onSignIn }) {
  const [form] = Form.useForm();
  const { setUserInfo } = useAuthStore();
  const phoneNumber = Form.useWatch("phone", form);

  const [targetDate, setTargetDate] = useState();
  const [isSend, setIsSend] = useState(false);

  const [countDown] = useCountDown({
    targetDate,
    onEnd: () => {
      setIsSend(false);
    },
  });

  // 获取验证码
  const { runAsync: getVerifyCode } = useRequest(getCode, {
    manual: true,
  });

  // 重置密码
  const { runAsync: onResetPwd } = useRequest(resetPassword, {
    manual: true,
  });

  // 验证码
  const suffixNode = useMemo(() => {
    const isValid = /^1[3456789]\d{9}$/.test(phoneNumber);
    return (
      <div>
        {isSend ? (
          <div className={styles.primary_btn}>
            {Math.round(countDown / 1000)}
          </div>
        ) : (
          <div
            className={styles.primary_btn}
            onClick={async () => {
              if (!phoneNumber) {
                message.error("请输入手机号");
              }
              if (!isValid) return;
              setIsSend(true);
              setTargetDate(Date.now() + 2 * 60 * 1000);
              try {
                await getVerifyCode({
                  phone: phoneNumber,
                  codeType: "ResetPassword",
                });
                message.success("验证码发送成功");
              } catch (error) {
                console.log(error);
                message.error("验证码获取失败");
              }
            }}
          >
            获取验证码
          </div>
        )}
      </div>
    );
  }, [countDown, getVerifyCode, isSend, phoneNumber]);

  const onFinish = async (values) => {
    try {
      await onResetPwd(values);
      setUserInfo(null);
      onSignIn();
      message.success("重置密码成功");
    } catch (error) {
      message.error(error.message);
    }
  };

  return (
    <div className={styles.reset_password}>
      <img src={logo} alt="" />

      <div className={styles.title}>重置密码</div>
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          label="手机号"
          name="phone"
          layout="vertical"
          required
          rules={[
            {
              required: true,
              message: "请输入您的手机号",
            },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: "手机号格式有误",
            },
          ]}
        >
          <Input
            placeholder="请输入您的手机号"
            style={{ width: "400px", height: "48px" }}
          />
        </Form.Item>

        <Form.Item
          label="验证码"
          layout="vertical"
          name="code"
          rules={[
            {
              required: true,
              message: "请输入验证码",
            },
            {
              pattern: /^\d{6}$/,
              message: "验证码格式有误",
            },
          ]}
        >
          <Input
            placeholder="请输入您的验证码"
            style={{ width: "400px", height: "48px" }}
            suffix={suffixNode}
          />
        </Form.Item>

        <Form.Item
          label="重置密码"
          name="password"
          layout="vertical"
          rules={[
            {
              required: true,
              message: "请输入密码",
            },
            {
              min: 8,
              max: 16,
              message: "密码格式有误，请输入8-16位字符",
            },
          ]}
        >
          <Input.Password
            placeholder="请输入8-16位字符"
            style={{ width: "400px", height: "48px" }}
          />
        </Form.Item>

        <Form.Item
          label="确认重置密码"
          name="confirmPassword"
          layout="vertical"
          dependencies={["password"]}
          rules={[
            {
              required: true,
              message: "请再次输入密码",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("两次输入的密码不一致!"));
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="请输入8-16位字符"
            style={{ width: "400px", height: "48px" }}
          />
        </Form.Item>

        <Form.Item
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            type="primary"
            style={{ width: "340px", height: "48px", fontSize: "20px" }}
            htmlType="submit"
          >
            确认重置
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
